/**
 * PermissionsScreen — First launch flow.
 *
 * UI-INV-005: Leaf component, props only.
 */
import { ScreenShell } from "../components/ScreenShell";
import { ChecklistItem } from "../components/ChecklistItem";
import styles from "./PermissionsScreen.module.css";
import { TEST_IDS } from "../testing/testIds";
import { PrimaryAction } from "../primitives/PrimaryAction";
import { SecondaryAction } from "../primitives/SecondaryAction";

type Props = {
  onGranted: () => void;
  onSkip: () => void;
  onHearBell?: () => void;
};

export function PermissionsScreen({ onGranted, onSkip, onHearBell }: Props) {
  return (
    <ScreenShell label="One thing first" testId="permissions-screen">
      <h1 className={styles.heading}>The app needs to ring.</h1>
      <p className={styles.intro}>
        Bells mark transitions between sessions. They are how the retreat
        speaks. The app needs permission to play sound while your screen is
        dark.
      </p>

      {onHearBell && (
        <button
          type="button"
          className={styles.bellPreview}
          onClick={onHearBell}
          aria-label="Hear a sample bell"
        >
          <span className={styles.bellGlyph}>◯</span>
          <span className={styles.bellLabel}>Hear a bell</span>
        </button>
      )}

      {typeof Notification === 'undefined' && (
        <p className={styles.iosHint}>
          Add to Home Screen to enable background bells and notifications.
        </p>
      )}

      <div className={styles.list}>
        <ChecklistItem glyph="◯" title="Audio playback" body="plays bells, even when locked" />
        <ChecklistItem glyph="△" title="Keep awake" body="keeps the screen awake during the retreat" />
      </div>

      <div className={styles.ctas}>
        <PrimaryAction onClick={onGranted} testId={TEST_IDS.PERMISSIONS_GRANT_BTN}>Grant permissions</PrimaryAction>
        <SecondaryAction onClick={onSkip} testId={TEST_IDS.PERMISSIONS_SKIP_BTN}>Continue without sound</SecondaryAction>
      </div>
    </ScreenShell>
  );
}
